"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _preact = _interopRequireWildcard(require("preact"));

var _HeadMenu = _interopRequireDefault(require("./HeadMenu"));

var _render = require("../../utils/render.utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Menu = function Menu(_ref) {
  var label = _ref.label,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$linksRenderFunct = _ref.linksRenderFunction,
      linksRenderFunction = _ref$linksRenderFunct === void 0 ? null : _ref$linksRenderFunct;
  return (0, _preact.h)("nav", {
    className: "mtn-o-header__menu"
  }, (0, _preact.h)(_HeadMenu["default"], {
    id: "mtn-header-bottom-menu",
    isDropdown: true,
    forceLabelShow: true,
    label: label,
    labelIcon: 'chevron-down',
    content: (0, _preact.h)("div", {
      className: "mtn-m-menu"
    }, items.map(function (item, index) {
      return (0, _preact.h)("div", {
        id: "mtn-header-bottom-menu-section-".concat(index),
        className: "mtn-m-menu__section",
        key: index
      }, item.title ? (0, _preact.h)("h6", {
        id: "mtn-header-bottom-menu-title-".concat(index),
        className: "mtn-ts-h6 mtn-m-menu__title"
      }, item.title) : null, item.items && item.items.length ? (0, _preact.h)("ul", {
        id: "mtn-header-bottom-menu-list-".concat(index),
        className: "m-nav-list m-nav-list--left mtn-m-menu__list"
      }, item.items.map(function (i, linkIndex) {
        return (0, _preact.h)("li", {
          key: i.href,
          className: "mtn-m-menu__item"
        }, (0, _render.renderLink)(i.href, (0, _preact.h)("span", null, i.icon ? (0, _preact.h)("span", {
          className: "fa fa-".concat(i.icon)
        }) : null, i.label), 'mtn-m-menu__link', linksRenderFunction, "mtn-header-bottom-menu-link-".concat(index, "-").concat(linkIndex)));
      })) : null);
    }))
  }));
};

var _default = Menu;
exports["default"] = _default;